import { get, find, isEmpty } from 'lodash';
import { createOffer, createHostUpdate } from '../../../actions/contracts';

const submitSendOfferForm = (values, dispatch, props) => {
  const { isEditOffer, accessToken, contractData, showTSWarning } = props;
  const payload = get(props, 'payloadData');
  const message = get(values, 'message');
  const currentAddOns = !isEmpty(contractData) ? _.filter(contractData, { type: 'ITEM' }) : [];
  const analyticsProperties = {
    explanation: message,
    has_existing_add_ons: !!currentAddOns.length
  };

  const bookingData = find(payload.items, { type: 'BOOKING' });
  bookingData.info.explanation = message;
  const controlId = bookingData.info.booking_id;

  if (showTSWarning) {
    const socialEventsPolicyAccepted = get(values, 'host_social_events_policy_accepted');
    analyticsProperties.host_social_events_policy_accepted = socialEventsPolicyAccepted;
    bookingData.info.host_social_events_policy_accepted = socialEventsPolicyAccepted;
  }

  if (props.isHostUpdate) {
    return dispatch(createHostUpdate(payload, controlId, accessToken, response => {
      if (200 === response.statusCode) {
        const invoiceId = _.get(response, 'pending.master.invoice_id', '');
        const pendingContracts = _.get(response, 'pending.children', []);
        const pendingMaster = _.get(response, 'pending.master', {});
        pendingContracts.push(pendingMaster);

        const spaceRental = _.find(pendingContracts, { type: 'SPACE_RENTAL' }) || {};
        const spaceRentalBooking = _.get(spaceRental, 'meta.booking', {});
        spaceRentalBooking.listing = _.get(spaceRental, 'meta.listing', {});

        analyticsProperties.invoice_id = invoiceId;
        analyticsIntegrations.customOfferFormSubmitted(analyticsProperties, spaceRentalBooking, pendingContracts, true, isEditOffer);
        props.redirectToInboxDetails();
      }
    }));
  }

  dispatch(createOffer(payload, accessToken, response => {
    if (200 === response.statusCode) {
      const invoiceId = _.get(response, 'master.invoice_id', '');
      const pendingContracts = _.get(response, 'children', []);
      const pendingMaster = _.get(response, 'master', {});

      const spaceRental = _.find(pendingContracts, { type: 'SPACE_RENTAL' }) || {};
      const spaceRentalBooking = _.get(spaceRental, 'meta.booking', {});
      spaceRentalBooking.listing = _.get(spaceRental, 'meta.listing', {});

      pendingContracts.push(pendingMaster);
      analyticsProperties.invoice_id = invoiceId;
      analyticsIntegrations.customOfferFormSubmitted(analyticsProperties, spaceRentalBooking, pendingContracts, false, isEditOffer);
      props.redirectToInboxDetails();
    }
  }));
};

export default submitSendOfferForm;
